import React from 'react';

export const EditPencil = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8708 6.16749C16.1858 5.85249 16.3592 5.43416 16.3592 4.98916C16.3592 4.54416 16.1858 4.12582 15.8708 3.81082L14.5492 2.48916C14.2342 2.17416 13.8158 2.00082 13.3708 2.00082C12.9258 2.00082 12.5075 2.17416 12.1933 2.48832L3.33334 11.3208V15H7.01084L15.8708 6.16749ZM13.3708 3.66749L14.6933 4.98832L13.3683 6.30832L12.0467 4.98749L13.3708 3.66749ZM5.00001 13.3333V12.0125L10.8667 6.16416L12.1883 7.48582L6.32251 13.3333H5.00001ZM3.33334 16.6667H16.6667V18.3333H3.33334V16.6667Z"
      fill={color || '#6E6B8C'}
    />
  </svg>
);
